module.exports = __webpack_public_path__ + "static/media/livestream.ced190cd.png";